export default class ResponseFailedError extends Error {
  constructor(message, data) {
    super(message);
    this.name = "ResponseFailedError";
    this.data = data;
  }
}